export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Page non trouvée',
    description: 'La page que vous recherchez n\'existe pas',
    goBack: 'Retour à l\'accueil',
  },
  common: {
    loading: 'Chargement...',
    noData: 'Aucune donnée disponible',
    error: 'Une erreur est survenue, veuillez réessayer',
    retry: 'Réessayer',
    authExpired: 'Session expirée, veuillez vous reconnecter',
    requestFailed: 'Échec de la requête',
    networkError: 'Erreur réseau, vérifiez votre connexion',
    skipToContent: 'Aller au contenu principal',
  },
  nav: {
    dashboard: 'Tableau de bord',
    visa: 'Visa',
    cost: 'Coût',
    timezone: 'Fuseau horaire',
    tax: 'Fiscalité',
    guide: 'Guide',
    login: 'Connexion',
  },
  footer: {
    about: 'À propos',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Votre vie de nomade numérique, organisée',
      subtitle: 'Plateforme tout-en-un : suivi de visa, comparaison de coûts, coordination de fuseaux horaires, conformité fiscale et guides de voyage',
      cta: 'Commencer gratuitement',
      learnMore: 'En savoir plus',
    },
    features: {
      title: 'Fonctionnalités',
      visa: { title: 'Suivi de visa', desc: 'Suivez les types de visa, les validités et les rappels de renouvellement' },
      cost: { title: 'Comparaison de coûts', desc: 'Comparez les coûts de vie : logement, alimentation, transport et plus' },
      timezone: { title: 'Gestion des fuseaux', desc: 'Horloges multi-fuseaux et coordination de réunions inter-fuseaux' },
      tax: { title: 'Assistant fiscal', desc: 'Consultation des règles fiscales transfrontalières et alertes de résidence' },
      guide: { title: 'Guide de voyage', desc: 'Guides détaillés des destinations nomades numériques dans le monde' },
    },
    stats: {
      countries: 'Pays couverts',
      cities: 'Villes',
      languages: 'Langues',
    },
  },
  login: {
    login: 'Connexion',
    register: 'Inscription',
    subtitle: 'Connectez-vous à NomadMate pour gérer votre vie de nomade',
    registerSubtitle: 'Créez un compte pour commencer votre vie de nomade numérique',
    email: 'E-mail',
    emailPlaceholder: 'votre@email.com',
    emailInvalid: 'Veuillez entrer une adresse e-mail valide',
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Entrez votre nom d'utilisateur",
    password: 'Mot de passe',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Retapez le mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    loading: 'Connexion en cours...',
    error: 'Échec de connexion, veuillez réessayer',
    orContinueWith: 'Ou continuer avec',
    noAccount: "Pas encore de compte ?",
    hasAccount: 'Déjà un compte ?',
  },
  dashboard: {
    welcome: 'Bon retour, {name}',
    subtitle: 'Aperçu de votre vie de nomade',
    stats: {
      activeVisas: 'Visas actifs',
      daysUntilExpiry: "Jours avant expiration",
      citiesCompared: 'Villes comparées',
      timezones: 'Fuseaux suivis',
    },
    expiryAlerts: 'Alertes expiration visa',
    noAlerts: "Aucune alerte d'expiration",
    daysLeft: '{days} jours restants',
    worldClocks: 'Horloges mondiales',
    quickActions: 'Actions rapides',
    actions: {
      visa: 'Suivi visa',
      cost: 'Comparaison coûts',
      timezone: 'Fuseaux horaires',
      tax: 'Assistant fiscal',
      guide: 'Guide voyage',
    },
    recentActivity: 'Activité récente',
    noActivity: 'Aucune activité récente',
  },
  visa: {
    title: 'Gestion des visas',
    subtitle: 'Suivez et gérez vos informations de visa',
    searchPlaceholder: 'Rechercher un pays...',
    allRegions: 'Toutes les régions',
    regions: {
      europe: 'Europe',
      asia: 'Asie',
      americas: 'Amériques',
      oceania: 'Océanie',
    },
    noCountries: 'Aucun pays trouvé',
    requirements: 'Conditions',
    documents: 'Documents requis',
    track: 'Suivre ce visa',
    applyUrl: 'Lien de demande',
    myTracked: 'Mes visas suivis',
  },
  cost: {
    title: 'Coût de la vie',
    subtitle: 'Comparez les coûts de vie entre différentes villes',
    selectCities: 'Sélectionner des villes',
    selectHint: 'Sélectionnez 2 à 4 villes à comparer',
    compare: 'Comparer',
    selectedCount: '{count} villes sélectionnées',
    comparison: 'Comparaison',
    category: 'Catégorie',
    nomadScore: 'Score nomade',
    budgetFinder: 'Recherche de budget',
    budgetPlaceholder: 'Entrez le budget mensuel',
    findCities: 'Trouver des villes',
    aiSuggestion: 'Suggestions IA bientôt disponibles',
  },
  timezone: {
    title: 'Gestion des fuseaux',
    subtitle: 'Gérez vos horaires et réunions multi-fuseaux',
    addTimezone: 'Ajouter un fuseau',
    noTimezones: 'Cliquez ci-dessus pour ajouter des fuseaux',
    meetingScheduler: 'Planificateur de réunions',
    meetingHint: 'Sélectionnez les fuseaux des participants pour trouver le meilleur créneau',
    findMeeting: 'Trouver un créneau',
    finding: 'Recherche en cours...',
    bestTime: 'Meilleur créneau',
    workingOverlap: 'Chevauchement horaires de travail',
  },
  tax: {
    title: 'Assistant fiscal',
    subtitle: 'Calcul fiscal transfrontalier et conformité',
    rules: 'Règles fiscales',
    selectCountry: 'Sélectionner un pays',
    thresholdDays: 'Seuil de jours de résidence',
    days: 'jours',
    taxRates: 'Taux d\'imposition',
    reportingRequirements: 'Obligations déclaratives',
    importantDates: 'Dates importantes',
    residenceTracker: 'Suivi des jours de résidence',
    noResidenceDays: 'Aucun jour de résidence enregistré',
    riskIndicator: 'Indicateur de risque fiscal',
    noRiskData: 'Aucune donnée de risque disponible',
    countries: {
      portugal: 'Portugal',
      thailand: 'Thaïlande',
      spain: 'Espagne',
      germany: 'Allemagne',
      estonia: 'Estonie',
      georgia: 'Géorgie',
      croatia: 'Croatie',
      mexico: 'Mexique',
      colombia: 'Colombie',
      indonesia: 'Indonésie',
      japan: 'Japon',
      southKorea: 'Corée du Sud',
      unitedKingdom: 'Royaume-Uni',
      unitedStates: 'États-Unis',
    },
  },
  guide: {
    title: 'Guide de voyage',
    subtitle: 'Guides des destinations nomades numériques dans le monde',
    allContinents: 'Tous',
    noCities: 'Aucune ville trouvée',
    backToList: 'Retour à la liste',
    internetQuality: 'Qualité Internet',
    safetyRating: 'Indice de sécurité',
    climate: 'Climat',
    communitySize: 'Taille de la communauté',
    coworkingSpaces: 'Espaces de coworking',
    noCoworking: 'Aucun espace de coworking disponible',
    day: 'jour',
  },
  settings: {
    title: 'Paramètres',
    subtitle: 'Gérez votre compte et vos préférences',
    profile: 'Profil',
    username: "Nom d'utilisateur",
    email: 'E-mail',
    saveProfile: 'Enregistrer le profil',
    saving: 'Enregistrement...',
    language: 'Langue',
    notifications: 'Notifications',
    visaExpiryNotif: 'Rappels expiration visa',
    taxReminderNotif: 'Rappels fiscaux',
    appearance: 'Apparence',
    light: 'Clair',
    dark: 'Sombre',
    baseTimezone: 'Fuseau horaire de base',
    dangerZone: 'Zone de danger',
    dangerDesc: 'Ces actions sont irréversibles, procédez avec prudence',
    deleteAccount: 'Supprimer le compte',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteDesc: 'Cela supprimera définitivement votre compte et toutes vos données. Cette action est irréversible.',
    cancel: 'Annuler',
    confirm: 'Supprimer',
  },
  about: {
    title: 'À propos',
    subtitle: 'NomadMate - Assistant vie de nomade numérique',
    version: 'Version',
    versionNumber: '1.0.0',
    description: 'NomadMate est un assistant conçu pour les nomades numériques, offrant gestion de visa, comparaison de coûts de vie, gestion des fuseaux horaires, calcul fiscal et guides de voyage pour faciliter votre vie de nomade mondial.',
    openSource: 'Remerciements open source',
    openSourceDesc: 'Ce projet est construit sur les excellents projets open source suivants',
    contact: 'Nous contacter',
    support: 'Support technique',
    feedback: 'Commentaires',
    privacyPolicy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
  },
}
